var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#423DCF",
    d: "M.5 16C.5 7.423 7.423.5 16 .5S31.5 7.423 31.5 16 24.577 31.5 16 31.5.5 24.577.5 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#423DCF",
    d: "m21.547 16.854-8 4.977a1 1 0 0 1-.534.143.9.9 0 0 1-.498-.143c-.32-.177-.497-.497-.497-.889v-9.955c0-.356.213-.711.497-.89a.98.98 0 0 1 1.031.037l8 5.013a1 1 0 0 1 .463.853 1 1 0 0 1-.462.854"
  })));
};
export default SvgPlay;